import React from 'react';

import EMETTable from './table/EMETTable';

const index = (props) => (
    <EMETTable />
);

export default index;
